export default function createServiceProfile({ next, store }) {
  const status = store.getters['auth/getRole']
  if (status === 'Employee' || status === 'Super-admin') {
    return next()
  }
  return next({ name: 'misc-not-authorized' })
}
